(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jspdf"), require("html2canvas"));
	else if(typeof define === 'function' && define.amd)
		define("html3pdf", ["jspdf", "html2canvas"], factory);
	else if(typeof exports === 'object')
		exports["html3pdf"] = factory(require("jspdf"), require("html2canvas"));
	else
		root["html3pdf"] = factory(root["jspdf"], root["html2canvas"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__9676__, __WEBPACK_EXTERNAL_MODULE__7498__) {
return 